export default "__VITE_ASSET__DLZelihw__"